import React, { useState } from "react";
import { X } from "lucide-react";

export function Field({ label, children, hint }) {
  return (
    <div>
      <label className="block text-xs font-bold uppercase tracking-wider text-earth/60 mb-1.5">{label}</label>
      {children}
      {hint && <p className="text-xs text-earth/40 mt-1">{hint}</p>}
    </div>
  );
}

const inputCls = "w-full px-3 py-2 rounded-md bg-parchment border hairline outline-none focus:border-gold text-earth";

export function TextInput(props) {
  return <input {...props} className={inputCls} />;
}
export function TextArea(props) {
  return <textarea {...props} className={inputCls} />;
}
export function Select({ children, ...props }) {
  return <select {...props} className={inputCls}>{children}</select>;
}

export function Modal({ title, onClose, children, wide }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center bg-earth/40 backdrop-blur-sm p-4 overflow-y-auto" onClick={onClose} data-testid="admin-modal">
      <div className={`bg-surface-card border hairline rounded-lg w-full ${wide ? "max-w-3xl" : "max-w-lg"} my-8`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b hairline sticky top-0 bg-surface-card rounded-t-lg">
          <h3 className="text-xl text-earth" style={{ fontWeight: 600 }}>{title}</h3>
          <button onClick={onClose} className="text-earth/50 hover:text-earth" data-testid="modal-close"><X size={22} /></button>
        </div>
        <div className="p-5 space-y-4">{children}</div>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    new: "bg-gold/20 text-gold-dark", pending: "bg-gold/20 text-gold-dark",
    pending_request: "bg-gold/20 text-gold-dark", pending_payment: "bg-gold/20 text-gold-dark",
    approved: "bg-sage/30 text-[#4a5a3e]", confirmed: "bg-sage/30 text-[#4a5a3e]",
    confirmed_request: "bg-sage/30 text-[#4a5a3e]", published: "bg-sage/30 text-[#4a5a3e]",
    contacted: "bg-earth/10 text-earth", converted: "bg-sage/30 text-[#4a5a3e]",
    completed: "bg-sage/30 text-[#4a5a3e]", draft: "bg-earth/10 text-earth/60",
    closed: "bg-earth/10 text-earth/50", cancelled: "bg-destructive/10 text-destructive",
    no_show: "bg-destructive/10 text-destructive", waitlist: "bg-earth/10 text-earth/60",
    rejected: "bg-destructive/10 text-destructive",
  };
  return <span className={`inline-block text-xs font-semibold px-2.5 py-1 rounded-full capitalize ${map[status] || "bg-earth/10 text-earth/60"}`}>{(status || "").replace(/_/g, " ")}</span>;
}

export function Card({ children, className = "" }) {
  return <div className={`bg-surface-card border hairline rounded-lg ${className}`}>{children}</div>;
}

export function useToggle(init = false) {
  const [v, setV] = useState(init);
  return [v, () => setV(!v), setV];
}

export const inputClass = inputCls;
